import { useMutation, useQueryClient } from "@tanstack/react-query";
import { voidPurchaseCreditNote } from "api/purchaseCreditNote.api";
import {
  invalidatePurchaseCreditNoteSide,
  invalidateVendorSide,
} from "lib/cacheInvalidation";

export const useVoidPurchaseCreditNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }) => voidPurchaseCreditNote(id, { reason }),
    onSuccess: () => {
      invalidatePurchaseCreditNoteSide(queryClient);
      invalidateVendorSide(queryClient);
    },
  });
};
